export const REPAIR_PARTS_QUERY_KEY = 'repairParts' as const;

export const repairPartsKeys = {
  all: () => [REPAIR_PARTS_QUERY_KEY] as const,

  search: (params: Record<string, unknown>) =>
    [REPAIR_PARTS_QUERY_KEY, 'search', params] as const
} as const;
